module.exports = __webpack_public_path__ + "img/team.bacf2963.png";